import { ComponentPropsWithoutRef } from 'react';
import { Typography } from '../../../ui';

export function Heading2(props: ComponentPropsWithoutRef<'h2'>) {
  const { children, ...rest } = props;

  return (
    <Typography
      as="h2"
      variant="body-l"
      weight="medium"
      className="text-grayscale600"
      {...rest}
    >
      {children}
    </Typography>
  );
}
